import { render, staticRenderFns } from "./password-security.vue?vue&type=template&id=38cd1c61"
import script from "./password-security.vue?vue&type=script&lang=js"
export * from "./password-security.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports